import { Navigate, Outlet, NavLink } from "react-router-dom";
import { useCloudAuth } from "../../hooks/useCloudAuth";

export function AdminLayout() {
  const { user, loading, isAuthenticated, isAdmin, logout } = useCloudAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0a0a0a]">
        <div className="w-6 h-6 border-2 border-blue-400 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!isAuthenticated || !user) {
    return <Navigate to="/" replace />;
  }

  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  const navLinks = [
    { to: "/admin", label: "Users", end: true },
    { to: "/admin/instances", label: "Instances" },
    { to: "/admin/plans", label: "Plans" },
    { to: "/admin/settings", label: "Settings" },
    { to: "/admin/updates", label: "Updates" },
  ];

  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      {/* Header */}
      <header className="h-14 bg-[#111] border-b border-[#333] px-4 flex items-center justify-between">
        <div className="flex items-center gap-6">
          <NavLink to="/" className="text-[#f5f5f5] font-bold text-sm">
            CloseCode ADE Cloud
          </NavLink>
          <div className="flex items-center gap-1 text-[#666] text-sm">
            <NavLink to="/dashboard" className="hover:text-[#999]">
              Dashboard
            </NavLink>
            <span>/</span>
            <span className="text-purple-400">Admin</span>
          </div>
          <nav className="flex items-center gap-4">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.end}
                className={({ isActive }) =>
                  `text-sm font-medium transition-colors ${
                    isActive ? "text-[#f5f5f5]" : "text-[#999] hover:text-[#f5f5f5]"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>
        </div>
        <div className="flex items-center gap-4">
          <span className="text-[#999] text-sm">{user.email}</span>
          <button
            onClick={logout}
            className="text-[#999] text-sm hover:text-[#f5f5f5] transition-colors"
          >
            Logout
          </button>
        </div>
      </header>

      {/* Content */}
      <main>
        <Outlet />
      </main>
    </div>
  );
}
